import { useContext } from "react";
import { useSelector } from "react-redux";

import { RightArrowIcon } from "../../../client/assets/icons/common/RightArrowIcon";
import { RightIcon } from "../../../client/assets/icons/thecreditreview/RightIcon";
import { getAwardText, getCompanyPhoneNumber } from "../../../selectors";
import { BaseBenefitsList } from "../../BaseComponents/BaseBenefitsList";
import { BaseCafNumber } from "../../BaseComponents/BaseCafNumber";
import { BaseCallOut } from "../../BaseComponents/BaseCallOut";
import { BaseColorBarRatingSection } from "../../BaseComponents/BaseColorBarRatingSection";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "../../BaseComponents/BaseCompanyName";
import { BaseFeaturedCompanyHeader } from "../../BaseComponents/BaseFeaturedCompanyHeader";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import BasePhoneLink from "../../BaseComponents/BasePhoneLink";
import BaseReviewLink from "../../BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../CompanyList/CompanyContext";
import { getStyles } from "./styles";

export const TCRLegacyLayout = () => {
	const { company, isFeaturedCompany } = useContext(CompanyContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles({ awardText });
	const phoneNumber = useSelector((state) =>
		getCompanyPhoneNumber(state, { company }),
	);
	const companyName = company?.fields?.companyName;

	return (
		<div
			className={`tw-relative tw-mx-auto tw-max-w-[500px] tw-bg-white md:tw-mx-[initial] md:tw-max-w-none ${isFeaturedCompany ? "tw-mt-[2rem] tw-rounded-[0.25rem] [border:1.5px_solid_#4299e1]" : "tw-mt-[1.125rem] tw-rounded-[3px] tw-shadow-[0_1px_2px_rgba(0,0,0,0.07)] [border:1px_solid_#d6dbdf]"}`}
		>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />

			<div className="tw-relative tw-flex tw-flex-col desktop:tw-flex-row">
				<BaseServiceFlag classNames={styles.serviceFlag} />

				<div className="tw-pb-[10px] tw-pt-[20px] xs2:tw-pb-0 xs2:tw-pt-[20px] md:tw-p-[20px] desktop:tw-flex desktop:tw-w-[40%] desktop:tw-p-0">
					<div className="tw-flex tw-flex-col tw-items-center tw-justify-center desktop:tw-w-full">
						<BaseLinkWrapper className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
							<BaseCompanyLogo classNames={styles.companyLogo} />

							<BaseCafNumber className={styles.cafNumber} />
						</BaseLinkWrapper>

						<BaseReviewLink
							classNames={styles.rightSecitonReviewLink}
							linkText="Read Full 2025 Review"
							suffixIcon={
								<RightIcon className="tw-text-[18px] tw-text-[#333742]" />
							}
						/>
					</div>

					<div className="tw-mt-[4px] tw-hidden tw-w-full tw-px-[10px] tw-py-[5px] md:tw-flex desktop:tw-mt-0 desktop:tw-w-fit desktop:tw-p-0">
						<BaseColorBarRatingSection classNames={styles.ratingSection} />
					</div>
				</div>

				<div className="tw-flex tw-flex-col tw-items-center tw-p-[10px] xs2:tw-p-[20px] md:tw-flex-row md:tw-justify-between md:tw-py-0 desktop:tw-w-[60%] desktop:tw-justify-between desktop:tw-p-[20px]">
					<BaseLinkWrapper className="tw-flex tw-w-full tw-flex-col xs2:tw-mx-auto xs2:tw-max-w-[380px] md:tw-mx-[initial] desktop:tw-max-w-[280px] lg2:tw-max-w-[380px]">
						<BaseCompanyName className="tw-font-[Montserrat] tw-text-[1.375rem] tw-font-semibold tw-leading-[1.3] tw-text-[#333742]" />

						<BaseCallOut className={styles.callOut} />

						<BaseBenefitsList
							{...styles.benefitsList}
							isExpandable={true}
							mobileItemsToShow={2}
						/>
					</BaseLinkWrapper>

					<div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center xxs2:tw-flex-row md:tw-w-auto md:tw-flex-col desktop:tw-mt-0 desktop:tw-w-fit desktop:tw-flex-col desktop:tw-items-center desktop:tw-justify-center lg2:tw-mr-0">
						<BasePhoneLink
							company={company}
							className="tw-relative tw-mb-[10px] tw-h-[52px] tw-w-auto tw-max-w-[300px] tw-rounded-[3px] tw-pb-[13px] tw-pl-[15px] tw-pr-[10px] tw-pt-[15px] [border:1px_solid_#d6dbdf] before:tw-absolute before:tw-left-[5px] before:tw-top-[15px] before:tw-h-[24px] before:tw-w-[24px] before:tw-bg-[url(/public/react-images/common/phone.svg)] before:tw-bg-[length:30px_20px] before:tw-bg-no-repeat xxs2:tw-mb-0 xxs2:tw-mr-[15px] md:tw-mx-0 md:tw-mb-[25px] md:tw-h-auto md:tw-w-full md:tw-border-none md:tw-py-0 md:tw-pl-[40px] md:tw-pr-0 md:before:tw-left-0 md:before:tw-top-[5px] md:before:tw-h-[34px] md:before:tw-w-[34px] md:before:tw-bg-[length:initial]"
						>
							<span className="tw-hidden tw-font-[AvenirNextLTPro-Demi] tw-text-[1rem] tw-font-medium tw-leading-[1.1] tw-tracking-[-0.05em] tw-text-[#333742] md:tw-block">
								Free Credit Consultation
							</span>
							<span className="tw-relative tw-bottom-[-2px] tw-pl-[20px] tw-font-[AvenirNextLTPro-Demi] tw-text-[1.2rem] tw-font-medium tw-leading-[1.1] tw-tracking-[-1px] tw-text-[#1d8ce0] md:tw-pl-0 md:tw-text-[1.5rem]">
								{phoneNumber}
							</span>
						</BasePhoneLink>

						<BaseLinkWrapper className="tw-group tw-relative tw-mt-[15px] tw-inline-flex tw-w-[160px] tw-items-center tw-justify-center tw-rounded-[3px] tw-bg-[#6ac54e] tw-p-[10px] tw-text-white tw-shadow-[0_3px_8px_#2a5a1b54] hover:tw-bg-[#14a929] xxs2:tw-mt-0 md:tw-w-[210px] md:tw-px-[20px] md:tw-py-[13px]">
							<BaseVisitLink {...styles.visitLink} icon={<RightArrowIcon />}>
								{companyName && (
									<small className="tw-block tw-font-[AvenirNextLTPro-Demi] tw-text-[12px] tw-text-white/80">
										{companyName}
									</small>
								)}

								<span className="tw-block tw-font-[Montserrat] tw-text-[1.3rem]">
									Visit Website
								</span>
							</BaseVisitLink>
						</BaseLinkWrapper>

						{phoneNumber == null && (
							<BaseReviewLink
								classNames={styles.reviewLink}
								linkText="Read Our Review"
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
